<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT_SPARE_PART|Użyto produkty' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <div class="mb-2 w-100">
            <div class="complaint-spare-parts-container__select__name">{{ 'PRODUCT|Produkt' | translate }}</div>

            <div class="complaint-spare-parts-container">

                <div class="complaint-spare-parts-container__select">

                    <div class="row" >
                        <ng-select
                            autocomplete="off"
                            [(ngModel)]="productId"
                            [ngModelOptions]="{standalone: true}"
                            [virtualScroll]="true"
                            [searchable]="true"
                            [notFoundText]="'INTERFACE|Brak wyników' | translate"
                            (change)="handleSparePart($event)"
                            [appendTo]="'body'"
                        >
                            <ng-option [value]="0">{{ 'INTERFACE|Nie wybrano' | translate }}</ng-option>
                            <ng-option *ngFor="let product of productsList" [value]="product.id">{{ product.name }}</ng-option>
                        </ng-select>

                    </div>
                </div>

                <button
                    iccButton
                    (click)="addSparePartToComplaint()"
                    appearance="primary"
                    [disabled]="!productId"
                >
                    {{ 'INTERFACE|Dodaj' | translate}}
                </button>
            </div>

            <div class="complaint-spare-parts-list">
                <div class="complaint-spare-parts-list__items" *ngFor="let complaintSparePart of complaintSpareParts; index as i">
                    <span>{{ getProductName(complaintSparePart.productId) }}</span>
                    <icc-input
                        [(ngModel)]="complaintSparePart.quantity"
                        [type]="'number'"
                        [min]="0"
                        [max]="complaintSparePart.maxQuantity"
                        [step]="0.0001"
                        [placeholder]="'INTERFACE|Ilość' | translate"
                        (valueChange)="changedQuantity(complaintSparePart)"
                    ></icc-input>
                    <icc-select
                        size="small"
                        [value]="complaintSparePart.unitId + ':' + complaintSparePart.unitCode"
                        (change)="handleUnit($event, complaintSparePart)"
                        disabled="true"
                    >
                        <option *ngFor="let unit of getUnits(complaintSparePart.productId)" [value]="unit.id + ':' + unit.code">{{ unit.name | translate }}</option>
                    </icc-select>
                    <button
                        iccIconButton
                        (click)="removeSparePartFromList(complaintSparePart)"
                        [title]="'INTERFACE|Usuń' | translate"
                        appearance="flat"
                    >
                        <icc-icon name="close"></icc-icon>
                    </button>
                </div>
            </div>

        </div>
        <p *ngIf="invalidSpareParts" class="invalid-message">{{ 'COMPLAINT_SPARE_PART|Przekroczony stan magazynowy' | translate }}</p>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                iccButton
                (click)="save()"
                appearance="primary"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>